import { AppServices } from "../../config/entities";

export class CatalogService {
  constructor(private catalogName: string) {
    this.catalogName = catalogName;
  }

  async GetAll(searchText: string | undefined) {
    let url = this.catalogName;
    if (searchText) {
      url += "?searchText=" + searchText;
    }

    const response = await AppServices.Axios.get(url);
    console.log(response);
    return response.data;
  }

  async Get(id: string) {
    // console.log(`Get ${this.catalogName}`, id);
    const response = await AppServices.Axios.get(this.catalogName + "/" + id);
    // console.log(response);
    return response.data;
  }

  async Delete(selectedItemId: string | null) {
    if (selectedItemId) {
      // console.log("Delete", selectedItemId);
      const response = await AppServices.Axios.delete(
        this.catalogName + "/" + selectedItemId
      );
      // console.log("Delete response", response);
    }
  }

  async Update(model: any) {
    // console.log("Update", model);
    const response = await AppServices.Axios.put(this.catalogName, model);
    // return response.data;
    // console.log("Update response", response);
  }

  async Create(model: any) {
    // console.log("Create", model);
    const response = await AppServices.Axios.post(this.catalogName, model);
    return response.data;
    // console.log("Create response11111", response);
  }
}
